import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Card,
  Collapse,
  Steps,
  Spin,
  Col,
  Flex,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Button,
  Divider,
  Space,
  Descriptions,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import appLabel from "../../../../config/appLabel";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import { newGlAccountAction } from "../../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import styles from "../../../../assets/styles/styles";
import DetailsDepositForm from "./components/DetailsDepositForm";
import TermsForm from "./components/TermsForm";
import ChargesForm from "./components/ChargesForm";
import Preview from "./components/Preview";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const NewTermDepositAcc = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);

  const [searchParam, setSearchParam] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
  const [productData, setProductData] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);

  //   declared functions
  const onSearch = () => {
    // console.log(searchParam);
    // return;
    //clear form
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // setSearchParam("");
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo
              ? element.entityAccountNo
              : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo
              ? element.entityMobileNo
              : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.customerType ? element.customerType : "",
          });
        });

        // console.log(tempProducts[0]);
        // return;

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        // setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const getProductTemplate = (customerParam) => {
    const params = {
      activeOnly: true,
      clientId: customerParam.value,
      staffInSelectedOfficeOnly: true,
      templateType: "individual",
    };
    const url = `${apiConfig.LoanAccounts}/template`;

    let body = {
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        let tempProducts = [];
        let tempLoanOfficerOptions = [];

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.loanOfficerOptions?.forEach((element) => {
          tempLoanOfficerOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setLoanOfficerOptions(tempLoanOfficerOptions);
        setProductData(tempProducts);
        setShowDetailsForm(true);
        // setCustomerInfo(customerParam);
        setIsLoading(false);
      }
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    console.log(searchKey);
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }
  const forms = [
    <DetailsDepositForm
      // onFinish={onFinishDetailsForm}
      // form={form}
      // formData={formData.details}
      // accountLinkingOptions={accountLinkingOptions}
      // customerDetail={customerDetail}
      // productData={productData}
      // onChangeProduct={onChangeProduct}
      // loanOfficerOptions={loanOfficerOptions}
      // loanPurposeOptions={loanPurposeOptions}
      // fundOptions={fundOptions}
      // loanAccountDetails={loanAccountDetails}
      onSearch={onSearch}
      handleSearchInTable={handleSearchInTable}
      // customerInfo={customerInfo}
      // showDetailsForm={showDetailsForm}
      // termFrequencyTypeOptions={termFrequencyTypeOptions}
    />,

    <TermsForm
    // onFinish={onFinishTermsForm}
    // form={form}
    // formData={formData.terms}
    // // termFrequencyTypeOptions={termFrequencyTypeOptions}
    // repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
    // repaymentFrequencyNthDayTypeOptions={repaymentFrequencyNthDayTypeOptions}
    // repaymentFrequencyDaysOfWeekTypeOptions={repaymentFrequencyDaysOfWeekTypeOptions}
    // interestTypeOptions={interestTypeOptions}
    // amortizationTypeOptions={amortizationTypeOptions}
    // interestCalculationPeriodTypeOptions={interestCalculationPeriodTypeOptions}
    // transactionProcessingStrategyOptions={transactionProcessingStrategyOptions}
    // loanAccountDetails={loanAccountDetails}
    // allowPartialPeriodInterestCalcualtion={allowPartialPeriodInterestCalcualtion}
    // handleAllowPartialPeriodInterestCalcualtion={handleAllowPartialPeriodInterestCalcualtion}
    // handleIsEqualAmortization={handleIsEqualAmortization}
    // isEqualAmortization={isEqualAmortization}
    // productTemplate={productTemplate}
    // disbursementDataList={disbursementDataList}
    // setDisbursementDataList={setDisbursementDataList}
    />,

    <ChargesForm
    // formData={formData.charges}
    // form={form}
    // onFinish={onFinishChargesForm}
    // chargeOptions={chargeOptions}
    // loanCollateralOptions={loanCollateralOptions}
    // collateralTableSource={collateralTableSource}
    // setCollateralTableSource={setCollateralTableSource}
    // chargeTableSource={chargeTableSource}
    // setChargeTableSource={setChargeTableSource}
    // setIsLoading={setIsLoading}
    // userData={userData}
    // setChargesValue={setChargesValue}
    />,

    // <Preview formData={formData}
    //     loanAccountDetails={loanAccountDetails}
    //     productTemplate={productTemplate}
    //     customerInfo={customerInfo}
    // />
  ];

  //   previous and next command
  const onChange = (value) => {
    setCurrent(value);
  };
  const isLastStep = current === forms.length - 1;
  const nextButtonClick = () => {
    useForm.submit();
  };
  const prevButtonClick = () => {
    setCurrent(current - 1);
  };
  function onCancel() {
    navigate("/acc0105", { replace: false });
  }
  const onSubmit = (formValues) => {
    // formValues = {
    //   ...formData.details,
    //   ...formData.terms,
    // };
    // // CHARGES STICT VALUES
    // formValues.charges = formData.payLoadValues;
    // formValues.clientId = customerInfo.entityId;
    // formValues.allowOverdraft = false;
    // formValues.liabilityId = "";
    // formValues.limitLineNumber = "";
    // formValues.dateFormat = "dd MMMM yyyy";
    // formValues.monthDayFormat = "dd MMMM";
    // formValues.locale = "en";
    // delete formValues.customerSearch;
    // // console.log(formValues);
    // // return;
    // const body = {
    //   ...formValues,
    //   method: "POST",
    //   session,
    // };
    // setIsLoading(true);
    // BOM.FetchReqAction(body, apiConfig.savingsAccounts, (err, res) => {
    //   if (err) {
    //     BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
    //     setIsLoading(false);
    //   } else {
    //     BOM.AlertMsg(cnt.SUCCESS, labelConfig.newSavingsAccountMsg);
    //     navigate("/detail-savings-account", {
    //       state: {
    //         id: res.resourceId,
    //         statusValue: accountStatus.submittedAndPending,
    //       },
    //     });
    //     //STOP LOAD
    //     setIsLoading(false);
    //   }
    // });
  };
  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newDepositAccount}
        pageItems={staticConfig.newDepositAccountsBreadcrumbs}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={labelConfig.accountSetup} style={styles.cardWrapper}>
          <Row style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Row style={{ justifyContent: "space-between" }}>
                <Card style={styles.cardSteps}>
                  <Steps
                    current={current}
                    onChange={onChange}
                    direction="vertical"
                    style={{ height: "500px" }}
                    items={[
                      {
                        title: <Text strong>{labelConfig.details}</Text>,
                      },
                      {
                        title: <Text strong>{labelConfig.terms}</Text>,
                        disabled: !isProductSelected,
                      },
                      {
                        title: <Text strong>{labelConfig.settings}</Text>,
                        disabled: !isProductSelected,
                      },
                      {
                        title: (
                          <Text strong>{labelConfig.interestRateChart}</Text>
                        ),
                        disabled: !isProductSelected,
                      },
                      {
                        title: <Text strong>{labelConfig.charges}</Text>,
                        disabled: !isProductSelected,
                      },
                      {
                        title: <Text strong>{labelConfig.preview}</Text>,
                        disabled: !isProductSelected,
                      },
                    ]}
                  />
                </Card>

                {/* Form Section */}
                <Card style={styles.cardStepDisplay}>
                  <div>{forms[current]}</div>
                </Card>
              </Row>
            </Col>
          </Row>
          <Card
            style={{
              marginBottom: 25,
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Flex
              justify="space-between"
              style={{ paddingLeft: "10px", paddingRight: "40px" }}
            >
              {current === 0 && (
                <Button
                  style={{
                    width: "10%",
                    backgroundColor: "white",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                  }}
                  colortext="black"
                  onClick={onCancel}
                >
                  Cancel
                </Button>
              )}
              {current > 0 && (
                <Button
                  style={{
                    width: "10%",
                    backgroundColor: "#92428B",
                    color: "white",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                  }}
                  onClick={prevButtonClick}
                >
                  Prev
                </Button>
              )}
              {!isLastStep && (
                <Button
                  style={{
                    width: "10%",
                    backgroundColor: "#92428B",
                    color: "white",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                  }}
                  onClick={nextButtonClick}
                >
                  Next
                </Button>
              )}
              {isLastStep && (
                <Button
                  style={{
                    width: "10%",
                    backgroundColor: "white",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                  }}
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              )}
            </Flex>
          </Card>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewTermDepositAcc;
